















































































import { Vue, Component } from 'vue-property-decorator';
import { Swipe, SwipeItem, Lazyload, Image as VanImage } from 'vant';
import ListItem from '../components/ListItem.vue';
import { getDistrictList, getSwiperList } from '../api';
import generateConfig from '@/components/SyForm/FormConfig';

Vue.use(Swipe).use(SwipeItem).use(Lazyload).use(VanImage);

@Component({
  components: {
    ListItem,
  },
})
export default class Home extends Vue {
  images: string[] = [
    'https://image2.cqcb.com/d/file/headline/2021-01-19/7f91a10f3768684fc85519c8a6228b07.jpg',
    'https://image2.cqcb.com/d/file/headline/2021-01-19/86de2f2af64018b20ba793595225901c.png',
  ];
  currentSlide = 0;
  districtList: any[] = [];
  toutiaoList: any[] = [];

  async created() {
    // 标记进入过首页
    (window as any).$hasEnteredHomePage = true;
    const ret = await getDistrictList();
    this.districtList = ret.data;

    const res = await getSwiperList(4495);
    this.toutiaoList = res.data.slice(0, 4);
  }

  onSlideChange(index: number) {
    this.currentSlide = index;
  }
  onJump(item: any) {
    if (window.udid && item.dataType !== 7 && item.dataType !== 5) {
      const { id, classId, isVideo } = item;
      const option = {
        dt: isVideo ? 9 : 3,
        cid: classId,
        nid: id,
      };
      window.handleMessage(
        JSON.stringify({
          action: 'mJump',
          data: JSON.stringify(option),
        }),
      );
    } else {
      location.href = item.targetUrl;
    }
  }
}
